module.exports = __webpack_public_path__ + "static/media/wireframing_02.a400abf6.png";